// Blocked/Unavailable dates for camps (hardcoded - use booking management interface for dynamic dates)
// Format: YYYY-MM-DD
import { formatLocalYYYYMMDD } from '../utils/dateUtils';

export const blockedDates: string[] = [
  // Example dates - add your actual blocked dates here
  // '2025-01-15',
  // '2025-01-16',
  // '2025-02-10',
  // '2025-02-11',
];

// Get blocked dates for a specific date range
// campId is optional - if provided, checks camp-specific bookings
export const isDateBlocked = (date: Date, campId?: string): boolean => {
  const dateStr = formatLocalYYYYMMDD(date);
  
  // Check hardcoded blocked dates
  if (blockedDates.includes(dateStr)) {
    return true;
  }
  
  // Check confirmed bookings and manual blocks if campId is provided
  // Note: This is checked asynchronously in BookingPage component via cached blocked dates
  // This function only checks hardcoded blocked dates for synchronous date validation
  
  return false;
};

// Get all blocked dates in a range
export const getBlockedDatesInRange = (start: Date, end: Date): string[] => {
  const blocked: string[] = [];
  const current = new Date(start);
  
  while (current <= end) {
    if (isDateBlocked(current)) {
      blocked.push(formatLocalYYYYMMDD(current));
    }
    current.setDate(current.getDate() + 1);
  }
  
  return blocked;
};

